import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo } from "react";
import { useLoggedOutContactUsContextStore } from "./LoggedOutContactUsContextStore";
import { useBrandArticlesByNode } from "./useBrandArticlesByNode";
import { useLoggedOutUserType } from "./useLoggedOutUserType";
import { useRetailerArticlesByNode } from "./useRetailerArticlesByNode";
export var useLoggedOutHelpCenterArticle = function useLoggedOutHelpCenterArticle() {
  var _useLoggedOutUserType = useLoggedOutUserType(),
    isRetailer = _useLoggedOutUserType.isRetailer;
  var _useLoggedOutContactU = useLoggedOutContactUsContextStore(["issueL1", "issueL2", "issueL3"]),
    _useLoggedOutContactU2 = _slicedToArray(_useLoggedOutContactU, 1),
    _useLoggedOutContactU3 = _useLoggedOutContactU2[0],
    issueL1 = _useLoggedOutContactU3.issueL1,
    issueL2 = _useLoggedOutContactU3.issueL2,
    issueL3 = _useLoggedOutContactU3.issueL3;
  var _useRetailerArticlesB = useRetailerArticlesByNode(),
    retailerArticlesByNode = _useRetailerArticlesB.retailerArticlesByNode;
  var _useBrandArticlesByNo = useBrandArticlesByNode(),
    brandArticlesByNode = _useBrandArticlesByNo.brandArticlesByNode;
  var helpCenterArticles = useMemo(function () {
    if (isRetailer) {
      if (issueL1) {
        var retailerArticlesByIssueL1 = retailerArticlesByNode[issueL1];
        if (issueL2) {
          var retailerArticlesByIssueL2 = retailerArticlesByIssueL1[issueL2];
          if (issueL3) {
            var retailerArticlesByIssueL3 = retailerArticlesByIssueL2[issueL3];
            return retailerArticlesByIssueL3;
          }
          return retailerArticlesByIssueL2;
        }
        return retailerArticlesByNode[issueL1];
      }
    } else {
      if (issueL1) {
        var brandArticlesByIssueL1 = brandArticlesByNode[issueL1];
        if (issueL2) {
          var brandArticlesByIssueL2 = brandArticlesByIssueL1[issueL2];
          if (issueL3) {
            var brandArticlesByIssueL3 = brandArticlesByIssueL2[issueL3];
            return brandArticlesByIssueL3;
          }
          return brandArticlesByIssueL2;
        }
        return brandArticlesByNode[issueL1];
      }
    }
    return [];
  }, [brandArticlesByNode, isRetailer, issueL1, issueL2, issueL3, retailerArticlesByNode]);
  return {
    helpCenterArticles: helpCenterArticles
  };
};